import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 11.871L14.448 5.44301c.2875-.24507.6569-.37262 1.0344-.35716.3775.01547.7353.17282 1.0018.4406.2665.26778.4221.62626.4358 1.00382.0137.37756-.1156.74637-.362 1.03274L12.5 11.5 14 13l.746 3.6c.0731.4106.016.8338-.1634 1.2103-.1793.3766-.4718.6876-.8366.8897L10.5 20.5 8.99998 22l-5.52-5.6 1.52-1.53V8.00001h.451c.44331.00011.87402.1475 1.22445.41901.35043.27152.60072.65176.71155 1.08099l.613 2.37099z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6792 3.31398c-.683-.67765-1.5652-1.11855-2.5171-1.25802-.952-.13947-1.9236.02984-2.7723.4831-.8486.45325-1.5297 1.16658-1.9432 2.03531s-.5377 1.84712-.3544 2.79161l2.638-2.637.007.007c.2303-.23784.5056-.42749.8099-.55788.3043-.1304.6315-.19893.9625-.20161.331-.00268.6593.06054.9657.18599.3063.12545.5847.31061.8187.5447.2341.23408.4193.51242.5447.81878.1255.30635.1887.63462.186.96565-.0027.33104-.0712.65824-.2016.96252-.1304.30429-.32.57959-.5579.80985L14.6282 10.9c.9461.1886 1.9277.0678 2.7998-.3446.872-.4125 1.5882-1.09466 2.0425-1.94565.4543-.85099.6227-1.8256.4802-2.77969-.1425-.95408-.5883-1.83697-1.2715-2.51808v.002z",
    fill: "currentColor"
  }));
});